export const SIGNUP_TEXT = 'Sign Up'

export const LOGIN_TEXT = 'Log in'
